import ToggleButton from './ToggleButton.vue';

export default ToggleButton;
